import React, { useEffect, useState } from "react";
import NavigationBar from "../NavigationBar";
import SideNavigation from "../SideNavigation";
import { Form, Modal, Button,Card, CardColumns, Badge } from 'react-bootstrap';
import "../../styles/css/Project.css";
import micro_reporter_api from "../../apis/micro-reporter-api";
import project from "../../assets/img/projects.png";
import dots from "../../assets/img/dots.png";
import editIcon from "../../assets/img/compact-menu-edit.png";
import deleteIcon from "../../assets/img/compact-menu-delete.png";
import description from "../../assets/img/push-pin.png"
import dbConn from '../../assets/img/database-nav-icon.png';
import report_icon from '../../assets/img/report-nav-icon.png';
import searchImage from "../../assets/img/search.png";
import dbWhite from "../../assets/img/database_white.png";
import reportWhite from "../../assets/img/report_white.png";
import Utils from "../../libraries/utils";
import noProject from "../../assets/img/project_icon.png";

const ProjectList = (props) => {

  const [projectList,setProjectList] = useState([]);
  const [deleteProjectVars, setProjectVars] = useState({deleteValues: {projectName: "", projectId: "", dbs: 0, reports: 0}});
  const [modalShow, setModalShow] = useState(false);
  const [tempProjectList,setTempProjectList] = useState([]);
  const [showLoad, setShowLoad] = useState(false);

  useEffect(() => {
        getProjectList();
	},[]);
 
  const getProjectList = () => {

    (async () => {
      try{
        Utils.loadingScreen("show");
        setShowLoad(true);
        let user = JSON.parse(localStorage.getItem("user"));
				await micro_reporter_api.get(`/micro-reporter/project/all`).then((response) => {
					setProjectList(response.data);
          setTempProjectList(response.data);
          Utils.loadingScreen("hide");
          setShowLoad(false);
				})
      }catch (err){
          Utils.loadingScreen("hide");
          setShowLoad(false);
      }
  	})();

	};

  const reportClick = (item) =>{
    window.location.href = "/reports?projectId=" + item.project.id;
  };

  const openUpdateModal = (item) =>{ 
    window.location.href = "/project/form?id=" + item.project.id;
  };

  const dbConnection = (item) => {
    window.location.href = "/connections?projectId=" + item.project.id;
  };

  const deleteProjectWithId = () => {
    (async () => {
      try{
          Utils.loadingScreen("show");
          let user = JSON.parse(localStorage.getItem("user"));
          let headers = {"userId": user.id, "username":user.username, "relatedName": encodeURIComponent(deleteProjectVars.deleteValues.projectName), "relatedId": deleteProjectVars.deleteValues.projectId};
          const config = {headers};
          await micro_reporter_api.delete(`/micro-reporter/project/delete?id=${deleteProjectVars.deleteValues.projectId}`, config);
          window.location.reload();
          Utils.loadingScreen("hide");
      }catch (err){
        Utils.loadingScreen("hide");
    }
  })();
  };

  const search = (word) => {
    let temp = [];
    tempProjectList.map(item => {
      if (item.project.name.toLowerCase().includes(word.toLowerCase()) || item.project.description.toLowerCase().includes(word.toLowerCase())){
        temp.push(item);
      }
    });
    if(temp){
      setProjectList(temp);
      temp = [];
    }  
  };

  const deleteProject = (item) =>{
    setProjectVars({deleteValues: {projectName: item.project.name, projectId: item.project.id, dbs: item.databaseConnectionCount, reports: item.reportCount}});
    setModalShow(true);
  };

  const renderActions = (item) => {
    return(
        <div className="compact-menu-project">
            <img src={dots} alt="dots" className="compact-menu-user-dots"/>
            <div className="compact-menu-project-content">
                <ul>
                    <li>
                        <div onClick={() => reportClick(item)}>
                            <img src={report_icon} alt="permission"/>
                            <span style={{fontSize: "13px"}}>Reports</span>
                        </div>
                    </li>
                    <li onClick={() => dbConnection(item)}>
                        <div>
                            <img src={dbConn} alt="dbConnection"/>
                            <span style={{fontSize: "13px"}}>DB Connections</span>
                        </div>
                    </li>
                    <li>
                        <div onClick={() => openUpdateModal(item)}>
                            <img src={editIcon} alt="edit"/>
                            <span style={{fontSize: "13px"}}>Edit</span>
                        </div>
                    </li>
                    <li onClick={() => deleteProject(item)}>
                        <div>
                            <img src={deleteIcon} alt="delete"/>
                            <span style={{fontSize: "13px"}}>Delete</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );
    };

  const renderNoProjectDiv = () => {
    if(projectList && projectList.length > 0){
      return(
        <CardColumns style={{marginTop: '35px'}}>
          {projectList.map(result=>{
            return(
            <Card id="project-card">
              {renderActions(result)}
              <Card.Body>
              <Card.Img variant="top" src={project} title={result.project.name} alt="Micro Reporter" id="project" style={{width: "20px", height: "20px",position:'relative',top:'-5px'}} />
                <Card.Title id="card-title">{result.project.name}</Card.Title>
                <Card.Text id="card-text" title={result.project.description}>
                  {result.project.description}
                </Card.Text>
                <Card.Img variant="top" src={description} alt="Micro Reporter" id="project" style={{width: "13px", height: "13px", visibility: "hidden"}} />
                <Card.Text id="card-text">
                    <Button variant="primary" title="Database Connections" onClick={() => dbConnection(result)} style={{marginRight: "20px"}}>
                        <Card.Img variant="top" src={dbWhite} alt="Micro Reporter" id="project" style={{width: "16px", height: "16px", margin: "0 10px 5px 0"}} /> <Badge variant="light">{result.databaseConnectionCount}</Badge>
                        <span className="sr-only">unread messages</span>
                    </Button>
                    <Button variant="primary" title="Reports" onClick={() => reportClick(result)} style={{marginRight: "20px"}}>
                        <Card.Img variant="top" src={reportWhite} alt="Micro Reporter" id="project" style={{width: "16px", height: "16px", margin: "0 10px 5px 0"}} /> <Badge variant="light">{result.reportCount}</Badge>
                        <span className="sr-only">unread messages</span>
                    </Button>
                </Card.Text>
              </Card.Body>
            </Card>
            )
          }) }
        </CardColumns>
      )
    }else if(projectList.length == 0 && !showLoad){
      return(
        <div id="record-not-found-div-project">
            <div id="center-div-project">
                <img src={noProject} style={{width: "100px", marginTop: "20px", marginBottom: "15px"}} alt="No project found."/>
                <br/>
                <span>No project found, create a new one!</span>
            </div>
        </div>
    );
    }
      
  };

  return (
    <div>
      <SideNavigation current="projects" />
      <div className="page-order">
        <NavigationBar />
        <div id="user-list-panel">
            <div>
              <h5 className="page-title">Projects</h5>
            </div>
            <button type="button" className="btn btn-primary" variant="primary" id="project-add-button">
            <a className="link" href={"/project/form"}>
              Create
            </a>
            </button>

            <Form>
              <input type="text" name="search" id="userSearchInput" placeholder="Search Project" onChange={(event) => search(event.target.value)} className="extand"/>
              <img id="seacrhIcon" src={searchImage} alt="search" />
            </Form>
            {renderNoProjectDiv()}
        </div>
      </div>
      <DeleteReportModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        delete={deleteProjectWithId}
        setProjectVars={setProjectVars}
        projectVars={deleteProjectVars}
      />
    </div>
  );
}

function DeleteReportModal(props){
  return (
      <Modal
          {...props}
          aria-labelledby="contained-modal-title-vcenter"
          centered
      >
          <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                  <span id="connection-form-panel-title">Delete Project</span>
              </Modal.Title>
          </Modal.Header>
          <Modal.Body>
              {props.projectVars.deleteValues.dbs > 0 ? <div style={{padding: "5px 15px 5px "}}>
                    <span>
                        Are you sure want to delete this project?
                    </span>
                    <br/>
                    <span style={{fontSize: "13px", color: "#ff0000"}}>
                        This project has <b>{props.projectVars.deleteValues.dbs}</b> database connections and <b>{props.projectVars.deleteValues.reports}</b> reports.
                    </span>
                  </div> :
                  <div style={{padding: "5px 15px 5px "}}>Are you sure want to delete this project?</div>}
          </Modal.Body>
          <Modal.Footer>
              <Button variant="light" onClick={props.delete}>Delete</Button>
              <Button variant="success" onClick={()=>{
                  props.setProjectVars({deleteValues: {reportName: "", reportId: "", dbs: 0, reports: 0}});
                  props.onHide();
              }}
              >
                  Cancel
              </Button>
          </Modal.Footer>
      </Modal>
  );
};

export default ProjectList;
